import { ToastProps } from 'ps-shared-ui/v4/Toast';

export const TOAST_SUCCESS_OPTIONS: ToastProps = { duration: 3000, isCloseable: false, type: 'success' }
export const TOAST_ERROR_OPTIONS: ToastProps = { duration: 3000, isCloseable: false, type: 'error' }
